<template>
    <div>
        <p>
            <strong>Voltooi deze order</strong>
        </p>

        <b-alert :show="hasError" variant="danger" class="mb-3">
            Fout bij het voltooien van de order.
        </b-alert>

        <b-button @click="finish" variant="primary" :disabled="isSaving">
            <span v-if="!isSaving">Markeer als verzonden</span>
            <font-awesome-icon v-else icon="spinner" spin/>
        </b-button>
    </div>
</template>

<script>
export default {
    name: "OrderCompletionMarkSortingLocationAsComplete",

    props: {
        dispatchRequest: {required: true},
    },

    data() {
        return {
            isSaving: false,
            hasError: false,
        }
    },

    computed: {},

    mounted() {
    },

    methods: {
        getIdentifier() {
            return 'mark_dispatch_request_as_shipped'
        },
        isRequired(batchModelType, productIdentifier, dispatchRequest, sortingLocation) {
            return Promise.resolve(true)
        },
        finish() {
            this.isSaving = true
            this.hasError = false

            this.$http.post(`/api/rest/process-product/mark-dispatch-request-as-ready-to-ship/${this.dispatchRequest.id}`)
                .then(() => {
                    this.$emit('success')
                })
                .catch(() => {
                    this.hasError = true
                    this.isSaving = false
                })
        }
    },

    watch: {
        dispatchRequest(dispatchRequest) {
            // Mogelijk is het DRQ al op shipped gezet door een voorgaande stap
            if (['shipped', 'ready-to-ship'].includes(dispatchRequest?.status)) {
                this.isSaving = true
                this.$emit('success')
            }
        },
    }
}
</script>

<style scoped>

</style>
